<template>
    <el-dialog :visible.sync="show_dialog" :modal="modal" :width="`${width}%`" @close="closeDialog"
        @before-close="beforeCloseDialog" :center=center>
        <template slot="title">
            <slot name="title"></slot>
        </template>
        <slot name="body"></slot>
    </el-dialog>
</template>

<script>
export default {
    name: 'DialogCom',
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        modal: {
            type: Boolean,
            default: false
        },
        width: {
            type: Number,
            default: 30
        },
        center: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            show_dialog: false
        }
    },
    methods: {
        closeDialog() {
            this.$emit('closeDialog')
        },
        beforeCloseDialog(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    this.$emit('beforeCloseDialog')
                    done();
                })
                .catch(_ => { });
        },
    },
    watch: {
        dialog: {
            immediate: true,
            handler(n) {
                this.show_dialog = n
            }
        }
    },
}
</script>

<style scoped>
/* .dialog-com {
    
} */
</style>



// WEBPACK FOOTER //
// src/commonReform/DialogCom.vue